module.exports = new __parcel__URL__("door.dacf04e1.webp").toString();